import { Component, OnInit, OnDestroy, Input } from '@angular/core';

import { ISubscription } from 'rxjs/Subscription';

import Handsontable from 'handsontable';
import { HotRegisterer } from 'angular-handsontable';
import {Report} from '../shared/report.model';
import {ReportDataService} from '../report-data.service';

@Component({
  selector: 'app-order-or-lots',
  templateUrl: './order-or-lots.component.html',
  styleUrls: ['./order-or-lots.component.css']
})

export class OrderOrLotsComponent implements OnInit, OnDestroy {
  columns: Array<Object>;
  report: Report;
  data: any;
  reloadSubscription: ISubscription;

  constructor(private reportService: ReportDataService, private gridContext: HotRegisterer) {
  }

  ngOnInit() {
    this.report = this.reportService.getReport();
    this.columns = this.report.OrdersOrLots.columns;
    this.data = this.report.OrdersOrLots.data;
    this.reloadSubscription = this.reportService.getReload().subscribe(data => this.reload());
  }

  ngOnDestroy() {
    this.reloadSubscription.unsubscribe();
  }

  reload() {
    this.data = this.report.OrdersOrLots.data;
    const gridInstance = this.gridContext.getInstance('OrdersOrLots');
    gridInstance.loadData(this.data);
  }
}


// WEBPACK FOOTER //
// ./src/app/order-or-lots/order-or-lots.component.ts